"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _text = babelHelpers.interopRequireDefault(require("components/field/text"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _shareModal = babelHelpers.interopRequireDefault(require("share-modal"));

var _app = require("products/app");

var _jQuery = babelHelpers.interopRequireDefault(require("jQuery"));

var _contactInfo = require("contact-info");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function cleanMarkup(markup) {
  var toRemove = [{
    all: false,
    start: '<!--',
    end: '-->'
  }, {
    all: true,
    start: '<style',
    end: '</style>'
  }, {
    all: false,
    start: '<meta',
    end: '>'
  }, {
    all: false,
    start: '<link',
    end: '>'
  }, {
    all: false,
    value: '</meta>'
  }, {
    all: false,
    value: '<o:p>'
  }, {
    all: false,
    value: '</o:p>'
  }];
  var word = markup.indexOf('Word.Document') != -1;
  toRemove.filter(entry => word || entry.all).forEach(entry => {
    if (entry.value) {
      while (markup.indexOf(entry.value) != -1) markup = markup.replace(entry.value, '');

      return;
    }

    do {
      let begin = markup.indexOf(entry.start);
      if (begin == -1) return;
      let end = markup.indexOf(entry.end, begin + entry.start.length);
      let left = markup.substring(0, begin);
      let right = markup.substring(end + entry.end.length);
      markup = left + right;
    } while (true);
  });
  return markup;
}

class ProductSection extends _react.Component {
  render() {
    if (this.props.content) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "product-description-section"
      }, this.props.title ? /*#__PURE__*/_react.default.createElement("header", null, this.props.title) : null, /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: cleanMarkup(this.props.content)
        }
      }));
    }

    if (this.props.children) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "product-description-section"
      }, this.props.title ? /*#__PURE__*/_react.default.createElement("header", null, this.props.title) : null, /*#__PURE__*/_react.default.createElement("div", null, this.props.children));
    }

    return null;
  }

}

class Product extends _react.Component {
  static serverRender(page, group, product) {
    var recordPath = _exports.default.Link('product-detail', {
      group: group,
      record: product
    });

    var shareLink = _exports.default.GetShareLink('product-detail', {
      group: group,
      record: product
    });

    var groupList = [],
        current = group;

    while (current) {
      groupList.unshift({
        group: JSON.parse(JSON.stringify(current)),
        link: _exports.default.Link('shop', current)
      });
      current = current.parent;
    }

    var locationGroup = page.blockFromLayout('MainLayout', 'Locations').resolve();
    var locations = [].map.call(locationGroup.records, location => ({
      id: location.id,
      name: location.location,
      address: location.address,
      city: location.city,
      state: location.state,
      zip: location.zip
    }));
    var relatedProducts = [].map.call(product.related[product.tool.toolID], product => ({
      id: product.id,
      link: _exports.default.Link('product-detail', product),
      title: product.title,
      image_name: product.image_name
    }));
    product = JSON.parse(JSON.stringify(product));

    var productImages = _exports.default.Channel.tools.productsImages.lwp('find', {
      parent: product.id,
      $getRecordDetails: ['id', 'image_name'],
      $order: 'parent_index',
      $orderDir: 'asc'
    }).records.map(item => item.image_name);

    if (product.image_name) productImages.unshift(product.image_name);

    var documents = _exports.default.Channel.tools.productsDocuments.lwp('find', {
      parent: product.id,
      $getRecordDetails: ['id', 'documentFile_name', 'documentType'],
      $order: 'parent_index',
      $orderDir: 'asc'
    }).records.map(item => ({
      type: item.documentType,
      name: item.documentFile_name
    }));

    return `
			<div data-component="Product">${_server.default.renderToString( /*#__PURE__*/_react.default.createElement(Product, {
      groupList: groupList,
      product: product,
      productLink: recordPath,
      shareLink: shareLink,
      locations: locations,
      images: productImages,
      documents: documents,
      related: relatedProducts
    }))}</div>
			${page.inlineScript(`
				var groupList = ${JSON.stringify(groupList)};
				var product = ${JSON.stringify(product)};
				var productLink = ${JSON.stringify(recordPath)};
				var shareLink = ${JSON.stringify(shareLink)};
				var locations = ${JSON.stringify(locations)};
				var images = ${JSON.stringify(productImages)};
				var documents = ${JSON.stringify(documents)};
				var related = ${JSON.stringify(relatedProducts)};
				require('products/detail').default.clientRender(this.querySelector('[data-component=Product]'), groupList, product, productLink, shareLink, locations, images, documents, related);
			`)}
		`;
  }

  static clientRender(node, groupList, product, productLink, shareLink, locations, images, documents, related) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Product, {
      groupList: groupList,
      product: product,
      productLink: productLink,
      shareLink: shareLink,
      locations: locations,
      images: images,
      documents: documents,
      related: related
    }), node);
  }

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      location: "",
      productOption: null,
      productOptionIndex: -1,
      quantity: 1,
      submitting: false,
      submitted: false,
      image: props.images[0],
      lastHoverImage: props.images[0],
      hoverImage: props.images[0]
    };

    if (props.person) {
      Object.assign(this.state, props.person, {
        submitting: false,
        submitted: false
      });
    }

    this.share = this.share.bind(this);
    this.pickUp = this.pickUp.bind(this);
    this.gotPickupForm = this.gotPickupForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    var productOptions = this.props.product.purchaseOption == 'inStore' ? (this.props.product.options || "").split("\n") : [];
    productOptions = productOptions.map(item => {
      item = item.replace(/^\s*/, '').replace(/\s*$/, '');
      if (item.length == 0) return [];
      if (item[0] == '|' || item[0] == ',' || item[0] == ';') return [];
      var delimiter;
      var dd = {
        '|': item.indexOf('|'),
        ',': item.indexOf(','),
        ';': item.indexOf(';')
      };
      Object.keys(dd).forEach(key => {
        if (dd[key] == -1) delete dd[key];
      });
      if (Object.keys(dd).length == 0) return [item];

      for (var i in dd) {
        if (!delimiter) delimiter = i;else if (dd[i] < dd[delimiter]) delimiter = i;
      }

      return item.split(delimiter).map(v => v.replace(/^\s*/, '').replace(/\s*$/, ''));
    }).filter(v => v.length).map(v => ({
      price: v[0],
      sku: v[1] || "",
      upc: v[2] || "",
      title: v[3] || ""
    }));
    this.productOptions = productOptions;

    if (productOptions.length == 1) {
      this.state.productOption = productOptions[0];
      this.state.productOptionIndex = 0;
    }
  }

  share() {
    _shareModal.default.show(this.props.product.title, this.props.shareLink);
  }

  gotPickupForm(node) {
    this.form = node;
  }

  pickUp() {
    this.setState({
      submitting: false,
      submitted: false
    }, () => {
      (0, _jQuery.default)(this.form).slideToggle();
      var T = (0, _jQuery.default)(this.form).offset().top - (20 + document.querySelector('#navScroll').getBoundingClientRect().bottom);
      var S = document.scrollingElement || document.documentElement;
      var base = S.scrollTop;
      var delta = T - base;
      var A = new _animationHelper.default(500, 'ease', percent => S.scrollTop = base + percent * delta);
      A.start();
    });
  }

  get canSubmitForm() {
    return this.state.name && this.state.email && this.state.phone && this.state.location && this.state.productOptionIndex > -1;
  }

  componentDidMount() {
    if (!this.state.location) {
      (0, _contactInfo.getLocation)().then(info => {
        if (info.Location) this.setState({
          location: info.Location.id
        });
      });
    }
  }

  submitForm() {
    this.setState({
      submitting: true,
      submitted: false
    }, () => {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'data/pickup', true);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          this.setState({
            submitted: true,
            submitting: false
          });
        }
      };

      xhr.send(JSON.stringify({
        name: this.state.name,
        phone: this.state.phone,
        email: this.state.email,
        location: this.state.location,
        product: this.props.product.id,
        productOption: this.state.productOption,
        quantity: this.state.quantity
      }));
    });
  }

  locationForId(id) {
    return this.props.locations.filter(location => location.id == id)[0];
  }

  render() {
    const productOptions = this.productOptions;

    const t = s => s.replace(/^\s*/, '').replace(/\s*$/, '');

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-8 col-md-offset-2 services-detail product-detail"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "services-detail-header header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "inner-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navigation uppercase"
    }, /*#__PURE__*/_react.default.createElement("h4", null, this.props.groupList.map((item, index) => /*#__PURE__*/_react.default.createElement("span", {
      key: index
    }, index ? /*#__PURE__*/_react.default.createElement("span", null, " / ") : null, index != 1 ? /*#__PURE__*/_react.default.createElement("span", null, item.group.title) : /*#__PURE__*/_react.default.createElement("a", {
      href: item.link
    }, item.group.title))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "share-button",
      onClick: this.share
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Share")), /*#__PURE__*/_react.default.createElement("div", {
      className: "right"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "img-responsive share-icon",
      src: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/share-icon.png"
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "product-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "main-image"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "primary-image",
      style: {
        backgroundImage: `url(${this.state.image})`
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _classList.default.join('alternate-image', this.state.hoverImage == this.state.image ? '' : 'in'),
      style: {
        backgroundImage: `url(${this.state.lastHoverImage})`
      }
    })), this.props.images.length > 1 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "alternate-images"
    }, this.props.images.map(image => /*#__PURE__*/_react.default.createElement("img", {
      key: image,
      className: _classList.default.join('img-alternate', this.state.hoverImage == image ? 'active' : ''),
      src: `/t/width=1/height=1/square/width=50/scale/f${image}/image.jpg`,
      onMouseOver: () => this.setState({
        lastHoverImage: image,
        hoverImage: image
      }),
      onMouseOut: () => this.setState(state => ({
        hoverImage: state.image
      })),
      onClick: () => this.setState({
        lastHoverImage: image,
        hoverImage: image,
        image: image
      })
    }))) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "right"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "uppercase"
    }, this.props.product.title), this.props.product.purchaseOption == 'online' && this.props.product.buyOnlineLink || productOptions.length ? /*#__PURE__*/_react.default.createElement("div", {
      className: "button-wrapper"
    }, this.props.product.purchaseOption == 'online' && this.props.product.buyOnlineLink ? /*#__PURE__*/_react.default.createElement("a", {
      className: "pickup-btn buy-online-btn",
      href: this.props.product.buyOnlineLink
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "uppercase"
    }, "Buy Online")) : null, productOptions.length ? /*#__PURE__*/_react.default.createElement("div", {
      className: "pickup-btn",
      onClick: this.pickUp
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "uppercase"
    }, "In-Store Pick Up")) : null) : null)), /*#__PURE__*/_react.default.createElement("hr", {
      style: {
        marginBottom: '0px'
      }
    }), productOptions.length ? /*#__PURE__*/_react.default.createElement("div", {
      className: _classList.default.join('pickup-form', this.state.submitted ? 'sent' : null),
      ref: this.gotPickupForm
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "inner-content"
    }, this.state.submitted ? /*#__PURE__*/_react.default.createElement("div", {
      className: "thankYou",
      ref: node => node ? node.dataset.ready = 'true' : null
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "uppercase"
    }, "Thank You!"), /*#__PURE__*/_react.default.createElement("p", null, "We'll contact you as soon as your order is ready."), false && /*#__PURE__*/_react.default.createElement("p", null, "We'll see you soon at our ", /*#__PURE__*/_react.default.createElement("i", null, this.locationForId(this.state.location).name), " location.")) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "header"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "uppercase"
    }, "Pick Up In-Store"), /*#__PURE__*/_react.default.createElement("p", null, "Fill in your information and a preferred location. We'll have it ready for pick up within 2 hours. Your orders will remain available for 72 hours.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "simple-form"
    }, productOptions.length == 1 ? /*#__PURE__*/_react.default.createElement("p", {
      className: "price"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "large"
    }, productOptions[0].price), productOptions[0].title ? `\xa0- ${productOptions[0].title}` : null) : productOptions.map((option, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "radio price",
      key: index
    }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "radio-wrap"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "productOption",
      value: index,
      checked: this.state.productOptionIndex == index,
      onChange: event => this.setState({
        productOption: option,
        productOptionIndex: index
      }),
      disabled: this.state.submitting || this.state.submitted
    }), /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "large"
    }, option.price), option.title ? `\xa0- ${option.title}` : null)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group quantity"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control",
      type: "text",
      value: this.state.quantity,
      onChange: event => this.setState({
        quantity: event.target.value
      }),
      disabled: this.state.submitting || this.state.submitted,
      id: "quantityField"
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "quantityField"
    }, "Quantity")), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control",
      placeholder: "Your Name *",
      type: "text",
      value: this.state.name,
      onChange: event => this.setState({
        name: event.target.value
      }),
      disabled: this.state.submitting || this.state.submitted
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control",
      placeholder: "Email *",
      type: "email",
      value: this.state.email,
      onChange: event => this.setState({
        email: event.target.value
      }),
      disabled: this.state.submitting || this.state.submitting
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control",
      placeholder: "Phone *",
      type: "text",
      value: this.state.phone,
      onChange: event => this.setState({
        phone: event.target.value
      }),
      disabled: this.state.submitting || this.state.submitting
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-section-header"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Select your Store *")), this.props.locations.map(location => /*#__PURE__*/_react.default.createElement("div", {
      className: "radio",
      key: location.id
    }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "radio-wrap"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "location",
      value: location.id,
      checked: this.state.location == location.id,
      onChange: event => this.setState({
        location: location.id
      }),
      disabled: this.state.submitting || this.state.submitting
    }), /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "large"
    }, t(location.name)), `\xa0- ${t(location.address)}, ${t(location.city)}, ${t(location.state)} ${t(location.zip)}`))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "submit-wrap"
    }, /*#__PURE__*/_react.default.createElement("button", {
      disabled: !this.canSubmitForm && !this.state.submitting && !this.state.submitting,
      onClick: this.submitForm,
      className: "btn btn-primary"
    }, "Request Pick-Up")))) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "description"
    }, this.sections(), this.props.documents.length ? /*#__PURE__*/_react.default.createElement(ProductSection, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: "document-list"
    }, this.props.documents.map(document => /*#__PURE__*/_react.default.createElement("li", {
      key: document.name
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: document.name,
      target: "_blank",
      className: "document-link"
    }, document.type))))) : null, this.props.related.length ? /*#__PURE__*/_react.default.createElement(ProductSection, {
      title: "Related Products"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "product-group"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "product-grid"
    }, this.props.related.map(item => /*#__PURE__*/_react.default.createElement(_app.ProductItem, {
      key: item.id,
      product: item
    }))))) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "services-detail-footer"
    }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("a", {
      href: "shop",
      className: "uppercase"
    }, "View All Products")));
  }

  sections() {
    return [{
      title: 'Details',
      content: this.props.product.description
    }, {
      title: 'Features',
      content: this.props.product.features
    }, {
      title: 'Product Info',
      content: this.props.product.productInfo
    }, {
      title: 'How To Use',
      content: this.props.product.howToUse
    }].map(v => /*#__PURE__*/_react.default.createElement(ProductSection, babelHelpers.extends({
      key: v.title
    }, v)));
  }

}

exports.default = Product;